import { Paper } from '../../../Components/Base';
import { useAuthentication } from '../../../Contexts/AuthenticationProvider';
import ConfirmationSignOutModal from '../Components/ConfirmationSignOutModal';
import EditRoundedIcon from '../../../Components/Icons/EditRoundedIcon';
import ExitToAppRoundedIcon from '../../../Components/Icons/ExitToAppRoundedIcon';
import MenuItem from '../Components/MenuItem';
import useDisclosure from '../../../Utils/useDisclosure';
import { useConfig } from '../../../Contexts/ConfigProvider';

const MenuItems = () => {
  const { userPortal } = useConfig();

  const { logout } = useAuthentication();
  const {
    isOpen: isConfirmModalOpen,
    open: openConfirmModal,
    close: closeConfirmModal,
  } = useDisclosure();

  const handleEditProfile = async () => {
    const clientId = userPortal.client.id;
    const editProfileUrl = userPortal.userPortalUrl?.updateProfile;
    const redirectUrl = userPortal.redirectUrl.updateProfile;
    const callbackUrl = userPortal.callbackUrl.updateProfile;
    const url = editProfileUrl
      .replace('{client_id}', clientId)
      .replace('{redirect_uri}', redirectUrl)
      .replace('{callbackUrl}', callbackUrl);
    location.replace(url);
  };

  return (
    <>
      <Paper sx={{ borderRadius: { xs: 0, sm: 1 }, overflow: 'hidden' }}>
        <MenuItem
          icon={<EditRoundedIcon />}
          title={'แก้ไขข้อมูลส่วนตัว'}
          hasBackLink
          onClick={handleEditProfile}
        />
      </Paper>
      <Paper sx={{ mt: 1, borderRadius: { xs: 0, sm: 1 }, overflow: 'hidden' }}>
        <MenuItem icon={<ExitToAppRoundedIcon />} title={'ออกจากระบบ'} onClick={openConfirmModal} />
        <ConfirmationSignOutModal
          open={isConfirmModalOpen}
          onCancel={closeConfirmModal}
          onSignOut={logout}
        />
      </Paper>
    </>
  );
};

export default MenuItems;
